export { EstablishedArtistCaption } from './EstablishedArtistCaption';
